import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";


function ManualAccountingIndex() {
    const tableRef = React.createRef();
    const navigate = useNavigate();


    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadManualAccounting();
    }, []);

    const loadManualAccounting = async () => {
        try {
            setIsLoading(true);
            const res = await axios.get(API + "manualaccounting/", {
                headers: authHeader(),
            });

            let rowData = res.data.data || res.data.results || res.data;
            if (!Array.isArray(rowData)) rowData = [];

            setData(rowData);
            setIsLoading(false);
        } catch (error) {
            console.error("Error loading manual accounting:", error);
            setIsLoading(false);
        }
    };

    const handleEdit = (id) => {
        navigate("/editmanualaccounting", { state: { id } });
    };


    const handleDelete = (id) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to delete this Manual Entry?",
            buttons: [
                {
                    label: "Yes",
                    onClick: async () => {
                        try {
                            await axios.delete(API + `manualaccounting/${id}/`, {
                                headers: authHeader(),
                            });

                            setData(prev => prev.filter(item => item.id !== id));

                            toast.success("Manual Entry deleted successfully", {
                                position: "top-right",
                                autoClose: 1000,
                                theme: "light",
                            });
                        } catch (error) {
                            console.error("Delete error:", error);
                            toast.error("Failed to delete entry");
                        }
                    },
                },
                { label: "No", onClick: () => { } },
            ],
        });
    };

    return (
        <div className="page-wrapper">
            <ToastContainer />
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <MaterialTable
                            tableRef={tableRef}
                            isLoading={isLoading} // Use internal loading state to prevent crash
                            style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            title={<h5 className="mb-0">{t("Manual Accounting")}</h5>}
                            columns={[
                                {
                                    title: "Entry No",
                                    field: "accounting_number",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div
                                            className="hyperlink"
                                            onClick={() =>
                                                navigate("/viewmanualaccounting", {
                                                    state: rowData.id,
                                                })
                                            }
                                        >
                                            {rowData.accounting_number}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Date"),
                                    field: "entry_date",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div>
                                            {Helper.DateNormal
                                                ? Helper.DateNormal(rowData.entry_date)
                                                : rowData.entry_date}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Debit Account"),
                                    field: "debit_account",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: t("Credit Account"),
                                    field: "credit_account",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: t("Amount"),
                                    field: "amount",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div>
                                            {Helper.Amount
                                                ? Helper.Amount(rowData.amount)
                                                : rowData.amount}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Status"),
                                    field: "status",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div>
                                        {rowData.status}
                                        </div>
                                   
                                    ),
                                },
                            ]}
                            data={data || []}
                            actions={[
                                (rowData) =>
                                    rowData.status !== "Final" && {
                                        icon: () => (
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/static/images/ic-edit.svg"
                                                }
                                                alt="edit"
                                            />
                                        ),
                                        tooltip: "Edit",
                                        onClick: (event, rowData) => handleEdit(rowData.id),
                                    },
                                (rowData) =>
                                    rowData.status !== "Final" && {
                                        icon: () => (
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/static/images/ic-delete.svg"
                                                }
                                                alt="delete"
                                            />
                                        ),
                                        tooltip: "Delete",
                                        onClick: (event, rowData) => handleDelete(rowData.id),
                                    },
                            ]}
                            components={{
                                Toolbar: (props) => (
                                    <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                        <MTableToolbar {...props} />

                                        <Link className="navbar-brand m-0" to="/addmanualaccounting" >
                                            <button className="add-part btn btn-primary  mb-0" id="add-task" >+&nbsp; {t('New Accounting')}</button>
                                        </Link>

                                    </div>
                                ),
                            }}
                            options={{
                                headerStyle: { backgroundColor: "white", color: "#245C7F", fontSize: 12 },
                                rowStyle: (rowData, index) => ({ backgroundColor: index % 2 ? "#fff" : "inherit" }),
                                search: true,
                                paging: true,
                                pageSize: 10,
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                emptyRowsWhenPaging: false,
                                actionsColumnIndex: -1,
                            }}
                            localization={{ toolbar: { searchPlaceholder: t("Search Expenses") } }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManualAccountingIndex;
